export enum LensSettingArea {
  Task = 'task',
  Team = 'team',
  Sked = 'sked',
  Admin = 'admin',
  Other = 'other',
}

export type LensSetting = Record<LensSettingsOptions, LensSettingValue>;

export type LensSettingValue = {
  name: string;
  description: string;
  active: boolean;
};

export enum LensSettingsOptions {
  CompleteSubtasksInAnyOrder = 'completeSubtasksInAnyOrder',
  CompleteTasksWithoutSubtaskCompletion = 'completeTasksWithoutSubtaskCompletion',
  ViewAndCreateNotes = 'viewAndCreateNotes',
}
